import { render } from "./SummaryNavItem.vue?vue&type=template&id=3306098a&ts=true"
import script from "./SummaryNavItem.vue?vue&type=script&lang=ts"
export * from "./SummaryNavItem.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__